import { createStore, createEvent, sample } from 'effector';

export const $featureFlagStore = createStore<unknown>({});

// public events
export const setData = createEvent<unknown>();

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// actions
sample({
  clock: setData,
  target: $featureFlagStore,
});

